import { InputPayPalDepositPackagePurchase } from "@scrile/api-provider/dist/api/PayPalPurchaseProvider";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import providers from "../../../../lib/providers";
import { t } from "../../../../locales";

type RequestState = "success" | "canceled";

const open = (w: number, h: number) => {
  const left = window.screen.width / 2 - w / 2,
    top = window.screen.height / 2 - h / 2;
  const config = `width=${w}, height=${h}, top=${top}, left=${left}, toolbar=0, location=1, directories=0, status=0, menubar=0, scrollbars=1, resizable=0, copyhistory=0`;
  return window.open("about:blank", "_blank", config);
};

const waitRequestStatus = (getUrl: () => Promise<string>) => {
  return new Promise<RequestState>(async (resolve, reject) => {
    if ((window as any).setPayPalRequestStatus) {
      reject([new Error(t("Other payment in process"))]);
      return;
    }
    let requestStatus: RequestState;
    (window as any).setPayPalRequestStatus = (status: RequestState) => {
      requestStatus = status;
    };
    const tab = open(980, 900);
    if (!tab) {
      delete (window as any).setPayPalRequestStatus;
      reject([new Error(t("Cant create payment window"))]);
      return;
    }
    try {
      tab.location.href = await getUrl();
    } catch (e) {
      tab.close();
      reject(e);
    }
    const interval = setInterval(() => {
      if (tab.closed) {
        if (requestStatus === "success") {
          resolve("success");
        } else {
          resolve("canceled");
        }
        delete (window as any).setPayPalRequestStatus;
        clearInterval(interval);
      }
    }, 500);
  });
};

const makePurchase = async (getUrl: () => Promise<string>) => {
  const requestState = await waitRequestStatus(getUrl);
  if (requestState === "canceled") {
    // eslint-disable-next-line
    throw [new Error(t("Payment canceled"))];
  }
  return true;
};

export default function useController() {
  const sendSubmit = (data: InputPayPalDepositPackagePurchase): Promise<Transaction> => {
    return new Promise(async (resolve, reject) => {
      try {
        let timeout: ReturnType<typeof setTimeout>;
        const subscription = await providers.PaymentSystemsProvider.subscribeDepositPurchase((t) => {
          timeout && clearTimeout(timeout);
          subscription.unsubscribe();
          resolve(t);
        });
        try {
          await makePurchase(() => providers.PayPalPurchaseProvider.getDepositUrl({ data }));
        } catch (e) {
          subscription.unsubscribe();
          reject(e);
        }
      } catch (e) {
        reject(e);
      }
    });
  };

  return {
    sendSubmit,
  };
}
